import {
    FETCH_DAILY_SLEEP_DATA_REPORTS,
    FETCH_DAILY_SLEEP_DATA_REPORTS_FETCHING,
    FETCH_DAILY_SLEEP_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_SLEEP_DATA_REPORTS_FAIL,
    FETCH_WEEKLY_SLEEP_DATA_REPORTS,
    FETCH_WEEKLY_SLEEP_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_SLEEP_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_SLEEP_DATA_REPORTS_FAIL
} from '../../actions/sleepReportsActions';
import { RESET_PROFILE_PAGE } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    dailySleepData: [],
    dailySleepDataFetching: false,
    dailySleepDataFetchFail: false,
    weeklySleepData: [],
    weeklySleepDataFetching: false,
    weeklySleepDataFetchFail: false
};

// ======= Daily Fetching Handlers =======
const fetchDailySleepDataFetching = (state) => {
    return {
        ...state,
        dailySleepDataFetching: true,
        dailySleepDataFetchFail: false
    };
};

const fetchDailySleepDataSuccess = (state, action) => {
    return {
        ...state,
        dailySleepData: action.dailySleepData,
        dailySleepDataFetching: false,
        dailySleepDataFetchFail: false
    };
};

const fetchDailySleepDataFail = (state) => {
    return {
        ...state,
        dailySleepDataFetching: false,
        dailySleepDataFetchFail: true
    };
};

// ======= Weekly Fetching Handlers =======
const fetchWeeklySleepDataFetching = (state) => {
    return {
        ...state,
        weeklySleepDataFetching: true,
        weeklySleepDataFetchFail: false
    };
};

const fetchWeeklySleepDataSuccess = (state, action) => {
    return {
        ...state,
        weeklySleepData: action.weeklySleepData,
        weeklySleepDataFetching: false,
        weeklySleepDataFetchFail: false
    };
};

const fetchWeeklySleepDataFail = (state) => {
    return {
        ...state,
        weeklySleepDataFetching: false,
        weeklySleepDataFetchFail: true
    };
};

const resetToInitialState = () => INITIAL_STATE;

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_SLEEP_DATA_REPORTS_FETCHING]: fetchDailySleepDataFetching,
    [FETCH_DAILY_SLEEP_DATA_REPORTS_SUCCESS]: fetchDailySleepDataSuccess,
    [FETCH_DAILY_SLEEP_DATA_REPORTS_FAIL]: fetchDailySleepDataFail,
    [FETCH_WEEKLY_SLEEP_DATA_REPORTS_FETCHING]: fetchWeeklySleepDataFetching,
    [FETCH_WEEKLY_SLEEP_DATA_REPORTS_SUCCESS]: fetchWeeklySleepDataSuccess,
    [FETCH_WEEKLY_SLEEP_DATA_REPORTS_FAIL]: fetchWeeklySleepDataFail,
    [RESET_PROFILE_PAGE]: resetToInitialState
};

// ======= Default Action ======
export default function sleepDataReports(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailySleepData(payload, evictCache) {
    return {
        payload: payload,
        type: FETCH_DAILY_SLEEP_DATA_REPORTS,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function fetchWeeklySleepData(payload, evictCache) {
    return {
        type: FETCH_WEEKLY_SLEEP_DATA_REPORTS,
        payload: payload,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

// ======= Selectors =======
export const getDailySleepData = (state) => {
    return state.sleepDataReports.dailySleepData ? state.sleepDataReports.dailySleepData : null;
};

export const isDailySleepDataFetching = (state) => {
    return state.sleepDataReports.dailySleepDataFetching;
};

export const didDailySleepDataFetchFail = (state) => {
    return state.sleepDataReports.dailySleepDataFetchFail;
};

export const getWeeklySleepData = (state) => {
    return state.sleepDataReports.weeklySleepData ? state.sleepDataReports.weeklySleepData : null;
};

export const isWeeklySleepDataFetching = (state) => {
    return state.sleepDataReports.weeklySleepDataFetching;
};

export const didWeeklySleepDataFetchFail = (state) => {
    return state.sleepDataReports.weeklySleepDataFetchFail;
};
